/* globals $, leaderboard_data, query_string */
/* eslint-disable no-param-reassign */
import Table from 'bam-node-savant-table/table'

import { formatCapitals } from 'bam-node-baseball-savant/utils/format-capitals'
import { toFixed } from '../utils'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'evLeaderboard'

function populateUrl() {
    const url = `/leaderboard/statcast?type=${$('#ddlType').val()}&year=${$(
        '#ddlSeason'
    ).val()}&position=${$('#ddlPosition').val()}&team=${$(
        '#ddlTeamId'
    ).val()}&min=${$('#ddlMin').val()}&sort=${$('#sort').val()}&sortDir=${$(
        '#sortDir'
    ).val()}`
    return url
}
$(() => {
    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })
})

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPosition').change(() => {
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `Minimum BBE (${$('#ddlMin option:selected').text()})`
        )
    })
    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })

    if (query_string.type) {
        if (query_string.type.indexOf('team') > -1) {
            $('#team-ddl').hide()
        }
        $('#ddlType').val(query_string.type).attr('selected', true)
        $('#lblType').html($('#ddlType option:selected').text())
    }
    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(
            `Minimum BBE (${$('#ddlMin option:selected').text()})`
        )
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (query_string.position) {
        $('#ddlPosition').val(query_string.position).attr('selected', true)
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    const isBatter = $('#ddlType').val() === 'batter'
    if (isBatter) {
        $('#positionGroup').show()
    }

    if (leaderboard_data && leaderboard_data.length > 0) {
        const headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'player_name_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'entity_id',
            },
            {
                name: 'BBE',
                field: 'bip',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                toolTip: 'Batted Ball Events',
                displayFn: (val) =>
                    val !== undefined && val !== null
                        ? Number(val).toLocaleString()
                        : '--',
            },
            {
                name: 'LA (°)',
                field: 'launch_angle_avg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'LA SwSp%',
                field: 'sweet_spot_percent',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                toolTip: 'Launch Angle Sweet-Spot %',
                displayFn: toFixed(1, '--'),
            },

            {
                name: 'Max',
                field: 'exit_velocity_max',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'Avg',
                field: 'exit_velocity_avg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'EV50',
                field: 'avg_best_speed',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
                toolTip: `For a batter, EV50 is an average of the hardest 50% of his batted balls. For a pitcher it is the average of his softest 50% of batted balls allowed.`,
            },
            {
                name: 'FB/LD',
                field: 'exit_velocity_fbld',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'Max',
                field: 'distance_max',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: toFixed(0, '--'),
            },
            {
                name: 'Avg HR',
                field: 'distance_hr_avg',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: toFixed(0, '--'),
            },
            {
                name: '95 MPH+',
                field: 'hard_hit_ct',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) =>
                    val !== undefined && val !== null
                        ? Number(val).toLocaleString()
                        : '--',
            },
            {
                name: '%',
                field: 'hard_hit_percent',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: '% Swing',
                field: 'hard_hit_per_swing',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: '#',
                field: 'barrel_ct',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'Brls/BBE %',
                field: 'barrels_per_bip',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'Brls/PA %',
                field: 'barrels_per_pa',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: toFixed(1, '--'),
                highlight:
                    query_string.type &&
                    query_string.type.indexOf('pitcher') > -1
                        ? [12, 6, 0]
                        : [0, 6, 12],
            },
        ]

        if ($('#ddlType').val().indexOf('team') > -1) {
            headers[0].photo =
                '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />'
            headers[0].photoId = 'entity_team_id'
        } else {
            headers.splice(1, 0, {
                name: 'Team',
                field: 'entity_team_name_alt',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'entity_team_id',
                photoOnly: true,
            })
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // Fix to handle old urls that are column based
        let sortVal = $('#sort').val()
        if (!Number.isNaN(Number(sortVal))) {
            const header = headers[Number(sortVal)]

            if (header) {
                sortVal =
                    headers[Number(sortVal)].customSortField ||
                    headers[Number(sortVal)].field
            } else {
                sortVal = 'barrels_per_pa'
            }
        }

        // eslint-disable-next-line no-new
        new Table({
            id: tableDivId,
            secondaryHeaders: [
                {
                    name: '',
                    colspan: $('#ddlType').val().indexOf('team') === -1 ? 6 : 5,
                    headerClass: 'th-name-header',
                },
                {
                    name: 'Exit Velocity (MPH)',
                    colspan: 4,
                    headerClass: 'th-title-header',
                },
                {
                    name: 'Distance (ft)',
                    colspan: 2,
                    headerClass: 'th-title-header',
                },
                {
                    name: 'Hard Hit',
                    colspan: 3,
                    headerClass: 'th-title-header',
                },
                {
                    name: 'Barrels',
                    colspan: 4,
                    headerClass: 'th-title-header',
                },
            ],
            headers,
            defaultSort: sortVal,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            sortCallback(column, _, { state }) {
                const url = new URL(window.location)
                url.searchParams.set('sort', column)
                url.searchParams.set('sortDir', state)
                window.history.replaceState('', '', url.toString())
            },
            // PASS IN UNIQUE ROW ID... Use this for ajax calls
            subDataId: 'entity_id',
            showRank: true,
            repeatHeader: repeatHeaders,
            data: leaderboard_data,
        })
    }

    window.addEventListener('scroll', () => {
        if (!ticking && leaderboard_data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function eachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).first().addClass('fixed-header')

            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function eachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    if ($('#ddlType').val().indexOf('team') === -1) {
        $('#evLeaderboard').on(
            'click',
            '.default-table-row',
            function clickHandler() {
                const playerId = this.id.split('_')[1]

                if (
                    $(`#evLeaderboard-trSub_${playerId}`).is(':visible') ===
                    true
                ) {
                    $(`#evLeaderboard-trSub_${playerId}`).hide()
                } else {
                    $.ajax({
                        method: 'GET',
                        url: '/leaderboard/statcast',
                        data: {
                            type: query_string.type,
                            qt: 'details',
                            player_id: playerId,
                            year: $('#ddlSeason').val(),
                            min_ab: $('#ddlMin').val(),
                            player_type: $('#ddlType').val(),
                        },
                    }).done((json) => {
                        $(`#evLeaderboard-tdSub_${playerId}`).html(
                            `<div id="data_${playerId}"></div>`
                        )
                        $(`#evLeaderboard-trSub_${playerId}`).show()

                        for (let x = 0; x < json.length; x++) {
                            if (
                                json[x].play_id &&
                                Number($('#ddlSeason').val()) >= 2018 &&
                                json[x].showVideo
                            ) {
                                json[
                                    x
                                ].video = `<a href="/sporty-videos?playId=${json[x].play_id}" target="_blank"><img src="/site-core/images/video.png" title="Show Video" style="width: 25px; height: 13px; cursor: pointer;" /></a>`
                            } else {
                                json[x].video = ''
                            }
                        }
                        // eslint-disable-next-line no-new
                        new Table({
                            id: `data_${playerId}`,
                            headers: [
                                {
                                    name: 'Date',
                                    field: 'game_date',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                                {
                                    name: 'Pitcher',
                                    field: 'pitcher_name',
                                    headerClass:
                                        'th-component-header align-left',
                                    fieldClass: 'tr-data align-left',
                                    photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                                    photoId: 'pitcher',
                                },
                                {
                                    name: 'Batter',
                                    field: 'batter_name',
                                    headerClass:
                                        'th-component-header align-left',
                                    fieldClass: 'tr-data align-left',
                                    photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                                    photoId: 'batter_id',
                                },
                                {
                                    name: 'Event',
                                    field: 'events',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data capitalize-first',
                                    displayFn: (val) => formatCapitals(val),
                                },
                                {
                                    name: 'Exit Velocity',
                                    field: 'hit_speed',
                                    type: 'number',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                                {
                                    name: 'Launch Angle',
                                    field: 'hit_angle',
                                    type: 'number',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                                {
                                    name: 'Distance',
                                    field: 'hit_distance_sc',
                                    type: 'number',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                                {
                                    name: 'Video',
                                    field: 'video',
                                    headerClass: 'th-component-header',
                                    fieldClass: 'tr-data',
                                },
                            ],
                            data: json,
                        })
                    })
                }
            }
        )
    }
})
